import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';
import NoSearchHits from '../search-panel-no-hits';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import looppa from 'looppa';
import reduxUtils from 'util/redux';
import normaliseTrailingSlashes from 'util/misc/normalise-trailing-slash';
import { linkToDashboardByUser } from 'util/misc/link-to-dashboard';
import findLeafBySlug from 'util/misc/find-leaf-category-by-slug';

class SearchPanelCategoryList extends PureComponent {
    static propTypes = {
        categories: PropTypes.array.isRequired,
        routeParams: PropTypes.object,
        activeCategory: PropTypes.object,
        categoriesTotal: PropTypes.number.isRequired,
        fetchedCategories: PropTypes.array.isRequired,
        closeSearch: PropTypes.func.isRequired,
        commonCategories: PropTypes.array.isRequired,
        productsTotal: PropTypes.number.isRequired,
        routerRegistry: PropTypes.object.isRequired,
        term: PropTypes.string.isRequired,
        setActiveLeafCategory: PropTypes.func.isRequired,
        setPendingAutoscroll: PropTypes.func.isRequired,
        unlockScroll: PropTypes.func.isRequired,
        activeRegion: PropTypes.object,
        reset: PropTypes.func.isRequired,
    };

    constructor(props) {
        super(props);
        this.state = {
            items: (props.productsTotal > 0 || props.term.length > 0) ? props.categories : props.commonCategories,
        };
    }

    componentWillReceiveProps({ categories, productsTotal, commonCategories, term }) {
        if (productsTotal > 0 || term.length > 0) {
            this.setState({ items: categories });
        } else {
            this.setState({ items: commonCategories });
        }
    }

    onLinkClink = (slug) => {
        this.props.closeSearch();
        this.props.reset();
        this.props.unlockScroll();

        // if we are in a page with leaf categories
        // a click might trigger an autoscroll
        // see also https://jira.migros.net/browse/MCART-2340
        const leafCategorySlug = slug.split('/').pop();
        if (
            this.props.activeCategory &&
            leafCategorySlug &&
            this.props.routeParams && this.props.routeParams.leafCategory &&
            leafCategorySlug !== this.props.routeParams.leafCategory
        ) {
            this.scrollToLeafCategory(leafCategorySlug);
        }
    };

    scrollToLeafCategory(leafSlug) {
        const activeLeafCategory = findLeafBySlug(this.props.activeCategory, leafSlug);

        if (activeLeafCategory) {
            this.props.setPendingAutoscroll({ mustAutoscroll: true });
            this.props.setActiveLeafCategory({ category: activeLeafCategory });
        }
    }

    render() {
        const { activeRegion } = this.props;
        const { items } = this.state;
        const url = linkToDashboardByUser(activeRegion);
        return (
            <div className="grid--row search-panel-category">
                <ul className="grid--col search-panel-category--list u-reset">
                    {items.length > 0 ? (
                        looppa(items)((item, i) => (
                            <li key={i}>
                                <Link
                                    onClick={() => this.onLinkClink(item.slug)}
                                    className="search-panel-category--link u-reset"
                                    to={normaliseTrailingSlashes(`${ url }${ item.slug }`)}
                                >
                                    {item.name}
                                </Link>
                            </li>
                        ))
                    ) : (
                        <NoSearchHits/>
                    )}
                </ul>
            </div>
        );
    }
}

export default connect(
    reduxUtils.mapStateToProps({
        categories: 'search.categories',
        activeCategory: 'categories.active',
        fetchedCategories: 'categories.items',
        categoriesTotal: 'search.categoriesTotal',
        commonCategories: 'search.commonCategories',
        activeRegion: 'region.active',
        routeParams: 'router.match.params',
        productsTotal: 'search.categoriesTotal',
        routerRegistry: 'router.registry',
        term: 'search.term',
    }),
    reduxUtils.mapDispatchToProps({
        closeSearch: 'search.close',
        unlockScroll: 'scroll.unlock',
        setActiveLeafCategory: 'categories.setActiveLeafCategory',
        setPendingAutoscroll: 'scroll.setPendingAutoscroll',
        reset: 'search.reset',
    }),
)(SearchPanelCategoryList);



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/main-header/search/search-panel-category-list/index.js